export default __webpack_public_path__ + "0e97d707db50c55a4b7197d6e33dfed2.svg";